export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "stream_worker.100186c1.worker.js");
}
